<template>
  <div class="info-text-box">
    <h2>{{ title }}</h2>
    <p>{{ text }}</p>
    <Btn
      v-if="btnText != '' && showBtn"
      :class="btnType"
      class="float-left"
      :icon="buttonIconCmp"
      :btnText="btnText"
      @btnClick="emitAction"
    />
  </div>
</template>

<script>
import Btn from '@/components/elements/buttons';

export default {
  name: 'InfoTextBox',
  components: {
    Btn,
  },
  props: {
    title: {
      type: String,
      default: 'Info Text Box Title',
    },
    text: {
      type: String,
      default: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Ut consectetur nunc tincidunt venenatis tincidunt.
                Aenean consectetur iaculis posuere.`,
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
    btnType: {
      type: String,
      default: 'brand',
    },
    btnText: {
      type: String,
      default: '',
    },
    btnIcon: {
      type: String,
      default: 'plus',
    },
    iconSize: {
      type: String,
      default: '18',
    },
  },
  computed: {
    buttonIconCmp() {
      return {
        name: this.btnIcon || 'plus',
        size: this.iconSize || '18',
      }
    },
  },
  methods: {
    emitAction() {
      this.$emit('action');
    },
  },
}
</script>
